import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';


const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'impressum',
    loadChildren: () => import('./pages/legal/imprint/imprint.module').then(m => m.ImprintModule)
  },
  {
    path: 'datenschutz',
    loadChildren: () => import('./pages/legal/privacy/privacy.module').then(m => m.PrivacyModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    relativeLinkResolution: 'legacy'
})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
